// extracted by mini-css-extract-plugin
module.exports = {"avatar-block":"UserAvatar_avatar-block__3BFLH"};